import {
  Combobox,
  DropdownButton,
  Icons
} from '@eggplant/pattern-library'
import { GetRequirementNamesRequest } from '@eggplant/api-requests'
import type {
  ButtonShape,
  DropdownPlacement,
  Options,
  Placement,
  Requirement
} from '@eggplant/types'

interface Props {
  isFilter?: boolean
  isFilterFixedMinMaxWidth?: boolean
  onChange: (value: string) => void
  placeholder?: string
  requirementGroupID: string
  value?: string
  isDisabled?: boolean
  placement?: Placement
  dropdownPlacement?: DropdownPlacement
}

const getOptions = (items: Requirement[]) =>
  items.map(({
    external_id,
    id
  }) => ({
    label: external_id,
    value: id
  }))

const dropDownIcon = () => <Icons.Requirements size='18' />

const SelectRequirement = ({
  isFilter = false,
  isFilterFixedMinMaxWidth = true,
  onChange,
  placeholder = 'Requirement',
  requirementGroupID,
  value,
  isDisabled = false,
  placement,
  dropdownPlacement = 'bottom'
}: Props) => {
  const renderButton = (options: Options) => {
    const currentOption = options.find(item => item.value === value)

    const label = currentOption?.value
      ? currentOption.label
      : placeholder

    const tooltip = currentOption?.value
      ? `Requirement: ${currentOption.label}`
      : label

    const buttonText = currentOption?.value
      ? currentOption.label
      : placeholder

    const noSelectedRequirementGroupTooltip = isDisabled
      ? 'Select a requirement group to enable requirement filter'
      : tooltip

    return (buttonProps: ButtonShape) =>
      <DropdownButton
        {...buttonProps}
        Icon={dropDownIcon}
        dropdownPlacement={dropdownPlacement}
        isDisabled={isDisabled}
        isFilter={isFilter}
        isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
        isHighlighted={!!value}
        label={label}
        placement={placement}
        title={noSelectedRequirementGroupTooltip}
      >
        {buttonText}
      </DropdownButton>
  }

  const param = {
    requirement_group_id: requirementGroupID
  }

  return requirementGroupID
    ? (
      <GetRequirementNamesRequest
        params={param}
        shortErrorMessage='Failed to load Requirement'
      >
        {
          (data: Requirement[]) =>
            <Combobox
              dropdownPlacement={dropdownPlacement}
              isDisabled={isDisabled}
              isFilter={isFilter}
              isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
              onChange={onChange}
              options={getOptions(data)}
              optionsLimit={100}
              placement={placement}
              renderButton={renderButton(getOptions(data))}
              value={value}
            />
        }
      </GetRequirementNamesRequest>
    )
    : (
      <Combobox
        isDisabled
        isFilter
        isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
        onChange={() => { }}
        renderButton={renderButton([])}
      />
    )
}

export default SelectRequirement
